import IBancoResponse from './IBancoResponse'

export enum ETipoPagamentoBoleto {
  IMEDIATO = 1,
  AGENDADO,
}
export interface IPagamentoBoletoResponse {
  protocolo?: string
  favorecido?: string
  codigo_barras: string
  valor: number
  tipo: string
  valor_total?: number
  valor_desconto?: number
  valor_multa?: number
  valor_juros?: number
  valor_original?: number
  data_vencimento: Date
  banco?: IBancoResponse
  tipo_pagamento?: ETipoPagamentoBoleto
  data_agendamento?: Date
}
